import { breakOptionsSchema } from 'api/services/zod-schemas/schema';
import { z } from 'zod';

const departmentSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const branchOfficeSchema = z.object({
  id: z.string(),
  name: z.string(),
  companyId: z.string(),
  departments: z.array(departmentSchema),
});

const jobGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  jobType: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    })
  ),
});

const certificateSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const defaultDepartmentLocationSchema = z.object({
  id: z.string(),
  address: z.string(),
});

export const getShiftCreateDataSchema = z.object({
  shiftCreateData: z.object({
    branchOfficeNames: z.array(branchOfficeSchema),
    breakOptions: z.array(breakOptionsSchema),
    jobGroups: z.array(jobGroupSchema),
    certificates: z.array(certificateSchema),
    defaultDepartmentId: z.string().nullish(),
    defaultDepartmentLocation: defaultDepartmentLocationSchema.nullish(),
  }),
});

export type GetShiftCreateData = z.infer<typeof getShiftCreateDataSchema>;
